import { Component, type ReactNode } from 'react'

interface Props {
  children: ReactNode
  fallback?: ReactNode
}
interface State {
  failed: boolean
}

// A malformed chart payload must never take down the whole view. Without this, one bad
// chart.data throws during render and React unmounts the tree → white screen, losing the
// text answer too. The boundary contains the failure to the chart slot and keeps the
// surrounding answer intact.
export class ChartErrorBoundary extends Component<Props, State> {
  state: State = { failed: false }

  static getDerivedStateFromError(): State {
    return { failed: true }
  }

  componentDidUpdate(prev: Props) {
    // Reset when a new chart is handed in, so a transient bad payload doesn't stick.
    if (prev.children !== this.props.children && this.state.failed) {
      this.setState({ failed: false })
    }
  }

  render() {
    if (this.state.failed) {
      return (
        this.props.fallback ?? (
          <figure className="chart-card">
            <div className="chart-area chart-empty">The chart could not be displayed.</div>
          </figure>
        )
      )
    }
    return this.props.children
  }
}
